import { type ResourceId } from '../common/structs';

export const pods = {
    admin: () => `${pods.collection}/admin` as const,
    collection: `/groups` as const,
    collections: `/groups/collections` as const,
    single: (id: ResourceId) =>
        ({
            canEdit: () => `${groupSingleUrl(id)}/can_edit` as const,
            canModerate: () => `${pods.single(id).members()}/can_moderate` as const,
            follow: () => `${groupSingleUrl(id)}/follow` as const,
            followers: () => `${groupSingleUrl(id)}/followers` as const,
            group: () => `${pods.collection}/${id}` as const,
            items: () => `${groupSingleUrl(id)}/items` as const,
            invite: () => ({
                create: () => `${groupSingleUrl(id)}/invites` as const,
                send: () => `${groupSingleUrl(id)}/members/invite` as const,
                accept: (inviteId: ResourceId) => `${pods.single(id).invites()}/${inviteId}/accept` as const,
                remove: (inviteId: ResourceId) => `${pods.single(id).invites()}/${inviteId}` as const,
            }),
            invites: () => `${groupSingleUrl(id)}/members/invites` as const,
            members: () => `${groupSingleUrl(id)}/members` as const,
            member: (memberId: ResourceId) => `${pods.single(id).members()}/${memberId}` as const,
            deleteMember: (memberId: ResourceId) => `/pods/${id}/members/${memberId}` as const,
            collections: () => `${groupSingleUrl(id)}/collections` as const,
        }) as const,
} as const;

const groupSingleUrl = (id: ResourceId) => pods.single(id).group();
